import React, {  } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from "@material-ui/core/Grid/Grid";

import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Typography from "@material-ui/core/Typography";

import TipoCorrecaoPieChart from "./TipoCorrecaoPieChart";
import AvancoParametrosBarChart from "./AvancoParametrosBarChart";


const useStyles = makeStyles(theme => ({

    mainGrid: {
      margin: 0,
      display: 'flex',
      height: '140mm',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      border: 1,
      borderStyle: 'solid',
      borderColor: 'black',
      borderRadius: '5px',
      flexGrow: 0
    },
    gridTitulo: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',


        border: 0,
        borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: "center",
        alignContent: 'center',
        border: 0,
        borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },


}));

const renderLoadingScreen = () => {
    const { classes } = this.props;
    return (
        <React.Fragment>
            {this.renderSearchComponent()}
            <div align="center">
                <CircularProgress className={classes.progress} />
            </div>
        </React.Fragment>
    )
}

export default function Avancos(props) {
  const { raspaReportData} = props;

  const classes = useStyles();


   const dadosTotaisAvanco =  [
        {
            tipoCorrecao: "SEM AVANCO",
            quantidade: raspaReportData.periodo.totaisGerais.numCiclos - raspaReportData.periodo.totaisGerais.qtdeAvancosExtras
        },
        {
            tipoCorrecao: "COM AVANCO",
            quantidade: raspaReportData.periodo.totaisGerais.qtdeAvancosExtras
        }
    ];

    return (
    <Grid container xs={12} className={classes.mainGrid}>
        <Grid container item id={'titulo'} className={classes.gridTitulo} sm={12} md={12}>
            <Typography>RASPAGENS COM AVANCOS EXTRAS REALIZADOS</Typography>
        </Grid>
        <Grid container item id={'titulo'} className={classes.gridTitulo} style={{ padding: '2px'}} sm={12} md={12}>
            <Grid container item id={'gridCorrecaoLado'} className={classes.gridItem} sm={4} md={4} >
                <TipoCorrecaoPieChart data={dadosTotaisAvanco}

                                      titulo={"AVANÇOS EXTRAS"}
                                      dataKeyX={"#"}
                                      height={250} width={250} legenda={false}/>
            </Grid>

            <Grid container item id={'gridCorrecaoAjuste'} className={classes.gridItem}  sm={8} md={8} >

                <AvancoParametrosBarChart data={raspaReportData.periodo.totaisAvancoParametros}

                                      titulo={"# RASPAGENS POR AJUSTE"}
                                      dataKeyX={"xx"}
                                      height={280} width={330} legenda={false} maxBarSize={20}/>

            </Grid>
        </Grid>
    </Grid>
  )
}
;
